import React, { useState, useRef, useEffect, useMemo } from "react";
import { useEtatGlobal } from "../../EtatGlobal.js";
import "../Suivi.css";
import { httpClient, authFetch } from "../../../HttpClient";
import { IoIosSearch } from "react-icons/io";
import { CiFilter } from "react-icons/ci";
import CreateTodo from "./JuridiquePonctuelle/createTodo.js";
import OverlayDetails from "./JuridiqueAGO/OverlayDetails.js";
import FicheClientOverlay from "../../Portefeuille/FicheClientOverlay";

import { dialog } from "../../../components/ui/Dialog";
import "../../ToDo/ToDo.css";
import { missionCommencee, missionActive, DEFAULT_AGO_YEAR, estBloque } from "./suiviProdUtils";
import BadgeBloque from "./BadgeBloque";
import {
  ExternalLink,
  ChevronDown,
  ArrowLeft,
  Shield,
  MessageSquare,
  FileText,
  FileSpreadsheet,
  Briefcase,
  History,
  Save,
  CheckCircle2,
  AlertTriangle,
  X,
  AlertCircle,
  ChartSpline,
  Scale,
} from "lucide-react";

const TABLE_FILTERABLE_COLUMNS = {
  statusBilan: { label: "Statuts bilan", type: "string" },
  status: { label: "Status", type: "string" },
  capitauxPropresReconstitue: {
    label: "Perte capitaux propres",
    type: "boolean",
  },
  depotGreffecheck: { label: "Dépôt greffe", type: "boolean" },
  recepissecheck: { label: "Récipissé dépôt", type: "boolean" },
  sd2777check: { label: "Dividendes / 2777-SD", type: "boolean" },
};

const SuiviJuridiqueAGO = ({ suiviJuridiqueData, loading, refetch }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [formData, setFormData] = useState(null);
  const [overlayData, setOverlayData] = useState(null);
  const [ficheClientOpen, setFicheClientOpen] = useState(false);
  const [ficheClientData, setFicheClientData] = useState(null);
  const [ficheClientLoading, setFicheClientLoading] = useState(false);
  const ficheClientCache = useRef({});
  const { utilisateur, patchSuiviJuridiqueAnnee, annuaireData } =
    useEtatGlobal();
  const [showCreateTodo, setShowCreateTodo] = useState(false); // nouvel état
  const [initialStatus, setInitialStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeSection, setActiveSection] = useState("Généralités");
  const [isAddingComment, setIsAddingComment] = useState(false);
  const [toggledComments, setToggledComments] = useState({});
  const [newCommentTexts, setNewCommentTexts] = useState({});
  const [openGroups, setOpenGroups] = useState({});
  const [annexeOpen2, setAnnexeOpen2] = useState(false);
  const [activeStatFilter, setActiveStatFilter] = useState("all");
  const [localSuiviJuridiqueData, setLocalSuiviJuridiqueData] =
    useState(suiviJuridiqueData);
  const [animatingId, setAnimatingId] = useState(null);

  const filterRef = useRef(null);

  const [activeColumnFilter, setActiveColumnFilter] = useState(null);
  const [columnFilterPosition, setColumnFilterPosition] = useState({
    top: 0,
    left: 0,
  });

  const Checkbool = (value) => (
    <div className="flex items-center gap-2">
      <div
        className={`w-4 h-4 rounded-full border flex items-center justify-center
          ${value ? "border-emerald-600" : "border-slate-400"}
        `}
      >
        {value && <div className="w-2 h-2 rounded-full bg-emerald-600" />}
      </div>
    </div>
  );

  const CheckboolS = (value) => (value ? "☒" : "☐");

  const sections = [
    "Généralités",
    "Confidentialité des comptes",
    "ART. L.223-42, R.223-36 / L.225648 R.225-166 CODE DU COMMERCE",
    "Commentaires",
    "Formalités / Déclarations",
    "Historique",
  ];

  const sectionIcons = {
    Généralités: FileSpreadsheet,
    "Confidentialité des comptes": Shield,
    "ART. L.223-42, R.223-36 / L.225648 R.225-166 CODE DU COMMERCE": Briefcase,
    Commentaires: MessageSquare,
    "Formalités / Déclarations": FileText,
    Historique: History,
  };

  const itemtype = "SuiviJuridique";

  const [filterRows, setFilterRows] = useState([
    { column: "formeSociale", selectedValues: [] },
  ]);

  const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setShowFilterOverlay(false);
      }
    };

    if (showFilterOverlay) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilterOverlay]);

  useEffect(() => {
    setSearchTerm("");
  }, [activeColumnFilter]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setActiveColumnFilter(null);
      }
    };

    if (activeColumnFilter) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeColumnFilter]);

  const handleResetColumnFilter = (column) => {
    setFilterRows((prev) =>
      prev.map((f) => (f.column === column ? { ...f, selectedValues: [] } : f))
    );
  };

  const [selectedYear, setSelectedYear] = useState(DEFAULT_AGO_YEAR);

  const showClientDetails = async (client) => {
    setFicheClientOpen(true);
    if (ficheClientCache.current[client.id]) {
      setFicheClientData(ficheClientCache.current[client.id]);
      setFicheClientLoading(false);
      return;
    }
    setFicheClientData(client);
    setFicheClientLoading(true);
    try {
      const { data } = await httpClient.get(
        `https://backend-myalfa.vercel.app/api/clients/${client.id}`
      );
      ficheClientCache.current[client.id] = data;
      setFicheClientData(data);
    } catch (err) {
      console.error("Erreur chargement client:", err);
    } finally {
      setFicheClientLoading(false);
    }
  };

  useEffect(() => {
    setLocalSuiviJuridiqueData(suiviJuridiqueData); // sync quand la prop change
  }, [suiviJuridiqueData]);
  // 🔹 Filtrage des clients avec useMemo
  const filteredClients = useMemo(() => {
    if (!localSuiviJuridiqueData?.length) return [];

    let filtered = localSuiviJuridiqueData
      // 🔎 Filtre recherche
      .filter((client) =>
        client.nom.toLowerCase().includes(searchTerm.toLowerCase())
      )
      // 🎛️ Filtres dynamiques existants
      .filter((client) =>
        filterRows.every((filter) => {
          if (!filter.selectedValues || filter.selectedValues.length === 0)
            return true;

          if (filter.column === "status") {
            const suiviForYear = client.suiviJuridique.find(
              (s) => s.annees === selectedYear
            );
            return suiviForYear
              ? filter.selectedValues.includes(suiviForYear.status)
              : false;
          }

          if (filter.column === "formeSociale") {
            if (!Array.isArray(client.formeSociale)) return false;
            return client.formeSociale.some((forme) =>
              filter.selectedValues.includes(forme)
            );
          }

          if (TABLE_FILTERABLE_COLUMNS[filter.column]) {
            if (filter.column === "statusBilan") {
              const bilan = client.suiviBilans?.find(
                (b) => b.annees === selectedYear
              );
              const value = bilan?.status ? bilan.status.trim() : null;
              return filter.selectedValues.includes(value);
            }

            const suivi = client.suiviJuridique?.find(
              (s) => s.annees === selectedYear
            );
            if (!suivi) return true;
            return filter.selectedValues.includes(suivi[filter.column]);
          }

          return filter.selectedValues.includes(client[filter.column]);
        })
      )

      // 📅 Filtre année
      .filter((client) => {
        const clotureYear = new Date(client.dateCloture).getFullYear();
        const hasBilanForYear = client.suiviBilans?.some(
          (b) => b.annees === selectedYear
        );
        return selectedYear >= clotureYear || hasBilanForYear;
      })
      // Mission pas encore débutée cette année-là → masqué ; client archivé
      // depuis une année antérieure → masqué aussi.
      .filter(
        (client) =>
          missionCommencee(client, selectedYear) &&
          missionActive(client, selectedYear),
      );

    // 🎯 Adapter le suivi à l’année sélectionnée
    return filtered.map((client) => {
      let suivi = client.suiviJuridique.find((s) => s.annees === selectedYear);
      if (!suivi) suivi = { annees: selectedYear, status: "" };
      const suiviBilan = client.suiviBilans.find(
        (b) => b.annees === selectedYear
      );

      return {
        ...client,
        suiviJuridique: [suivi],
        suiviBilans: suiviBilan ? [suiviBilan] : [],
      };
    });
  }, [localSuiviJuridiqueData, searchTerm, filterRows, selectedYear]);

  const availableYears = useMemo(() => {
    if (!suiviJuridiqueData || suiviJuridiqueData.length === 0) return [];

    const minYear = Math.min(
      ...suiviJuridiqueData.map((c) => new Date(c.dateCloture).getFullYear())
    );
    const maxYear = new Date().getFullYear() + 2; // tu peux adapter

    const years = [];
    for (let y = minYear; y <= maxYear; y++) {
      years.push(y);
    }
    return years;
  }, [suiviJuridiqueData]);

  const uniqueValues = useMemo(() => {
    if (!suiviJuridiqueData) return {};

    return {
      formeSociale: Array.from(
        new Set(
          suiviJuridiqueData
            .map((c) =>
              Array.isArray(c.formeSociale) ? c.formeSociale[0] : c.formeSociale
            )
            .filter((v) => v != null && v !== "")
        )
      ),

      regimeFiscal: Array.from(
        new Set(
          suiviJuridiqueData
            .map((c) => c.regimeFiscal)
            .filter((v) => v != null && v !== "")
        )
      ),

      regimeTVA: Array.from(
        new Set(
          suiviJuridiqueData
            .map((c) => c.regimeTVA)
            .filter((v) => v != null && v !== "")
        )
      ),

      status: Array.from(
        new Set(
          suiviJuridiqueData
            .flatMap((c) => c.suiviJuridique?.map((t) => t.status) || [])
            .filter((v) => v != null && v !== "")
        )
      ),
    };
  }, [suiviJuridiqueData]);
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const uniqueColumnValues = useMemo(() => {
    if (!localSuiviJuridiqueData) return {};

    const values = {};

    Object.keys(TABLE_FILTERABLE_COLUMNS).forEach((columnKey) => {
      const allValues = localSuiviJuridiqueData.flatMap((client) => {
        // 🔹 Cas spécial STATUS BILAN
        if (columnKey === "statusBilan") {
          const bilan = client.suiviBilans?.find(
            (b) => b.annees === selectedYear
          );
          return bilan?.status ? [bilan.status.trim()] : [];
        }

        // 🔹 Autres colonnes = suiviJuridique
        const suivi = client.suiviJuridique?.find(
          (s) => s.annees === selectedYear
        );

        if (!suivi) return [];

        const value = suivi[columnKey];
        return value !== undefined && value !== null
          ? [typeof value === "string" ? value.trim() : value]
          : [];
      });

      values[columnKey] = Array.from(
        new Set(allValues.filter((v) => v !== "")) // filtre valeurs vides
      );
    });

    return values;
  }, [localSuiviJuridiqueData, selectedYear]);

  const FilterableTableTh = ({ columnKey, label }) => {
    return (
      <th className="px-2 py-1.5 text-white font-semibold relative">
        <div className="flex items-center justify-center gap-1">
          {label}
          <button
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              setColumnFilterPosition({
                top: rect.bottom + 6,
                left: rect.left,
              });

              setActiveColumnFilter(
                activeColumnFilter === columnKey ? null : columnKey
              );
            }}
          >
            <ChevronDown className="w-3 h-3 text-white opacity-80 hover:opacity-100" />
          </button>
        </div>
      </th>
    );
  };
  // suiviJuridiqueId : id du SuiviJuridique renvoyé par le PUT (le suivi peut
  // venir d'être créé) — l'ancien envoi de « suiviBilanId » était refusé (400)
  // par le backend, l'historique AGO ne s'enregistrait jamais.
  const addHistoriqueSuiviJuridique = async (nouveauStatus, suiviJuridiqueId) => {
    try {
      if (!suiviJuridiqueId) return;

      await httpClient.post(
        "https://backend-myalfa.vercel.app/api/historiqueSuivijuridique",
        {
          titre: "Changement de status",
          description: `Changement de status en - ${nouveauStatus} - par ${utilisateur.lastName} ${utilisateur.name} `,
          suiviJuridiqueId,
        }
      );
      console.log("✅ Historique ajouté !");
    } catch (error) {
      console.error("❌ Erreur lors de l’ajout d’historique :", error);
    }
  };
  // 🔹 Handle Submit avec optimistic update
  const handleSubmit = async () => {
    if (!selectedClient) return;
    const clientId = selectedClient.client.id;
    const newStatus = formData.status;

    setIsSubmitting(true);

    // 1️⃣ Optimistic update : mise à jour immédiate du tableau ET du
    // suiviJuridiqueData global (EtatGlobal.js) — pas seulement l'état local
    // du composant — pour que ça survive à un changement d'onglet
    // (démontage/remontage de l'écran) ; localSuiviJuridiqueData se
    // resynchronise automatiquement dessus via le useEffect existant.
    patchSuiviJuridiqueAnnee(clientId, selectedYear, formData);

    // Animation validation si "Terminé"
    if (newStatus === "Terminé") {
      const row = document.querySelector(`[data-client-id="${clientId}"]`);
      if (row) row.classList.add("todo-row-validating");
      setAnimatingId(clientId);
      setTimeout(() => setAnimatingId(null), 1300);
    }

    // 2️⃣ On ferme le client immédiatement
    setSelectedClient(null);
    setIsSubmitting(false);

    // 3️⃣ Appel API en arrière-plan
    let suiviJuridiqueId = selectedClient?.suivi?.id;
    try {
      const response = await authFetch(
        `https://backend-myalfa.vercel.app/api/suiviJuridique/${clientId}/${selectedYear}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      if (!response.ok) throw new Error("Erreur lors de la mise à jour");
      const enregistre = await response.json().catch(() => null);
      if (enregistre?.id) suiviJuridiqueId = enregistre.id;
    } catch (error) {
      console.error(error);
      return;
    }

    // 🔹 Historique si le status a changé — fire-and-forget
    if (newStatus !== initialStatus) {
      addHistoriqueSuiviJuridique(newStatus, suiviJuridiqueId).catch(console.error);
      setInitialStatus(newStatus);
    }
  };

  const handleToggleStatus = async (idCommentaire) => {
    // Lit le statut actuel depuis l'état
    const currentStatus = toggledComments[idCommentaire];

    // Optimistic update
    setToggledComments((prev) => ({
      ...prev,
      [idCommentaire]: !currentStatus,
    }));

    try {
      const response = await authFetch(
        `https://backend-myalfa.vercel.app/api/commentairesSuiviJuridique/${idCommentaire}/toggle-status`,
        { method: "PATCH", headers: { "Content-Type": "application/json" } }
      );

      if (!response.ok) throw new Error("Erreur API");

      // Optionnel : synchroniser selectedClient si nécessaire
    } catch (error) {
      console.error("❌", error);

      // rollback en cas d'erreur
      setToggledComments((prev) => ({
        ...prev,
        [idCommentaire]: currentStatus,
      }));

      dialog.alert("Impossible de changer le statut du commentaire.");
    }
  };

  const handleAddComment = async (
    newCommentType,
    newCommentText,
    selectedClient,
    selectedYear,
    setNewCommentType,
    setNewCommentText,
    setSelectedClient // ajoute ceci pour mettre à jour le state
  ) => {
    const suiviBilanIndex = selectedClient.client.suiviJuridique.findIndex(
      (b) => b.annees === selectedYear
    );

    if (suiviBilanIndex === -1) {
      dialog.alert("Aucun suivi bilan trouvé.");
      return;
    }

    if (!newCommentText || !newCommentText.trim()) {
      dialog.alert("Le commentaire ne peut pas être vide.");
      return;
    }

    setIsAddingComment(true);

    try {
      const response = await authFetch(
        "https://backend-myalfa.vercel.app/api/commentairesSuiviJuridique",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            nomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
            commentaire: newCommentText.trim(),
            type: newCommentType,
            suiviJuridiqueId:
              selectedClient.client.suiviJuridique[suiviBilanIndex].id,
          }),
        }
      );

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Erreur lors de l'ajout du commentaire");
      }

      const createdComment = await response.json();

      // Ajoute le commentaire directement dans le state
      const updatedsuiviJuridique = [...selectedClient.client.suiviJuridique];
      updatedsuiviJuridique[suiviBilanIndex] = {
        ...updatedsuiviJuridique[suiviBilanIndex],
        commentaires: [
          ...(updatedsuiviJuridique[suiviBilanIndex].commentaires || []),
          createdComment,
        ],
      };

      setSelectedClient({
        ...selectedClient,
        client: {
          ...selectedClient.client,
          suiviJuridique: updatedsuiviJuridique,
        },
      });

      // Réinitialise les inputs
      setNewCommentText("");
      setNewCommentType("");
    } catch (err) {
      console.error(err);
    } finally {
      setIsAddingComment(false);
      // Ne pas mettre setSelectedClient(null)
    }
  };

  // 🔹 Gestion des filtres
  const handleAddFilter = () => {
    setFilterRows((prev) => [
      ...prev,
      { column: "formeSociale", selectedValues: [] },
    ]);
  };

  const handleRemoveFilter = (indexToRemove) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleFilterChange = (index, field, value) => {
    setFilterRows((prev) =>
      prev.map((f, i) =>
        i === index ? { ...f, [field]: value, selectedValues: [] } : f
      )
    );
  };

  const handleCheckboxValueChange = (index, value) => {
    setFilterRows((prev) =>
      prev.map((f, i) => {
        if (i !== index) return f;
        const selectedValues = f.selectedValues || [];
        const updated = selectedValues.includes(value)
          ? selectedValues.filter((v) => v !== value)
          : [...selectedValues, value];
        return { ...f, selectedValues: updated };
      })
    );
  };

  const handleResetFilters = () => {
    setFilterRows([{ column: "formeSociale", selectedValues: [] }]);
    setSearchTerm("");
  };

  // 🔹 Filtrage des données

  useEffect(() => {
    if (selectedClient) {
      const currentBilan =
        selectedClient?.client?.suiviJuridique?.find(
          (bilan) => bilan.annees === selectedYear
        ) || null;

      setFormData(
        currentBilan
          ? {
              status: currentBilan.status,
              lastStatus: currentBilan.lastStatus,
              holding: currentBilan.holding,
              associe: currentBilan.associe,
              personnePhysique: currentBilan.personnePhysique,
              LettreMisson: currentBilan.LettreMisson,
              capitauxPropres: currentBilan.capitauxPropres,
              exercice: currentBilan.exercice,
              capitauxPopresReconstitue: currentBilan.capitauxPopresReconstitue,
              remuneration: currentBilan.remuneration,
              convention: currentBilan.convention,
              reserveLegale: currentBilan.reserveLegale,
              reserveLegaleMontant: currentBilan.reserveLegaleMontant,
              dotee: currentBilan.dotee,
              dispense: currentBilan.dispense,
              sarl: currentBilan.sarl,
              aurtres: currentBilan.aurtres,
              report: currentBilan.report,
              comptesAnnuel: currentBilan.comptesAnnuel,
              courrier: currentBilan.courrier,
              feuillePresence: currentBilan.feuillePresence,
              texteDesResolution: currentBilan.texteDesResolution,
              rapportGestion: currentBilan.rapportGestion,
              rapportConvetion: currentBilan.rapportConvetion,
              rapportConseil: currentBilan.rapportConseil,
              rapportCAC: currentBilan.rapportCAC,
              procésVerbal: currentBilan.procésVerbal,
              extraitPV: currentBilan.extraitPV,
              declarationConfidentialite:
                currentBilan.declarationConfidentialite,
              pouvoir: currentBilan.pouvoir,
              depotGreffe: currentBilan.depotGreffe,
              depotGreffecheck: currentBilan.depotGreffecheck,
              depotGreffear: currentBilan.depotGreffear,
              recepisse: currentBilan.recepisse,
              recepissecheck: currentBilan.recepissecheck,
              recepissear: currentBilan.recepissear,
              sd2777: currentBilan.sd2777,
              sd2777check: currentBilan.sd2777check,
              sd2777ar: currentBilan.sd2777ar,
              ged: currentBilan.ged,
              annuelsComplet: currentBilan.annuelsComplet,
              resultatUniquement: currentBilan.resultatUniquement,
              dispenseAnnexe: currentBilan.dispenseAnnexe,
            }
          : {}
      );
    }
  }, [selectedClient, selectedYear]);

  const formatDateWithoutYear = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    return `${day}/${month}`;
  };

  const renderBool = (value) => (value ? "X" : "");

  // Quand on sélectionne un client, on mémorise aussi le status de départ
  const handleEditClick = (client, suivi) => {
    setSelectedClient({ client, suivi });
    setFormData(suivi ? { ...suivi } : { annees: selectedYear });

    // 🟢 on mémorise le status initial (ou "En préparation" si rien)
    setInitialStatus(suivi?.status || "En préparation");
  };

  const showOverlayDetails = (client, suivi, suiviBilan) => {
    setOverlayData({ client, suivi, suiviBilan });
  };

  // Groupement = les contacts de l'Annuaire liés au client (mêmes liens que
  // les "dossiers liés" de Annuaire.js et le regroupement de Portefeuille.js)
  // — on affiche le nom/prénom à jour (annuaireData, global) plutôt que le
  // snapshot embarqué sur le client.
  const getGroupementLabel = (annuaireId, fallbackContact) => {
    const contact =
      annuaireData.find((a) => a.id === annuaireId) || fallbackContact;
    return contact
      ? `${contact.nom || ""} ${contact.prenoms || ""}`.trim()
      : "";
  };

  const getRowColor = (status) => {
    switch (status) {
      case "Terminé":
        return "#e9f6ec";
      case "Signature":
        return "rgba(255, 215, 0, 0.3)";
      case "A faire":
      case "Rédaction":
      case "Supervision":
      case "Formalités":
        return "#fff8dc";
      default:
        return "#ffffff";
    }
  };

  // Les dossiers bloqués (litige) restent dans le tableau, grisés, mais ne
  // comptent dans aucun compteur — comme "Fin de mission" et "1er bilan en N+1".
  const clientsSansN1 = filteredClients.filter((item) => {
    const suivi = item.suiviJuridique?.[0];
    return (
      suivi?.status !== "1er bilan en N+1" &&
      suivi?.status !== "Fin de mission" &&
      !estBloque(item)
    );
  });

  // Dossier dont le bilan est en "1er bilan en N+1" → classé comme Terminé côté AGO
  const isBilanN1Client = (c) =>
    c.suiviBilans?.[0]?.status === "1er bilan en N+1";

  // Dossier dont l'AGO est en "Fin de mission" → grisé et classé comme
  // Terminé (visible dans l'onglet Terminé) mais exclu de clientsSansN1,
  // donc sans gonfler aucun compteur de la répartition par état — même
  // traitement que "Fin de mission" dans Suivi Bilan (SuiviBilan.js).
  const isFinDeMissionClient = (c) =>
    c.suiviJuridique?.[0]?.status === "Fin de mission";

  const KNOWN_AGO_STATUSES = [
    "A faire",
    "Rédaction",
    "Supervision",
    "Signature",
    "Formalités",
    "Terminé",
  ];

  // Filtre activeStatFilter appliqué uniquement pour le tableau
  const filterStatusMap = {
    afaire: "A faire",
    redaction: "Rédaction",
    supervision: "Supervision",
    signature: "Signature",
    formalites: "Formalités",
    termine: "Terminé",
  };
  const tableClients =
    activeStatFilter === "attentebilan"
      ? filteredClients.filter(
          (c) =>
            !KNOWN_AGO_STATUSES.includes(c.suiviJuridique[0]?.status) &&
            !isBilanN1Client(c) &&
            !isFinDeMissionClient(c)
        )
      : activeStatFilter === "termine"
      ? filteredClients.filter(
          (c) =>
            c.suiviJuridique[0]?.status === "Terminé" ||
            isBilanN1Client(c) ||
            isFinDeMissionClient(c)
        )
      : activeStatFilter !== "all" && filterStatusMap[activeStatFilter]
      ? filteredClients.filter(
          (c) =>
            c.suiviJuridique[0]?.status === filterStatusMap[activeStatFilter] &&
            !isBilanN1Client(c)
        )
      : filteredClients;

  // eslint-disable-next-line no-unused-vars
  const missionsTerminees = clientsSansN1.filter((item) => {
    const suivi = item.suiviJuridique?.[0];
    return suivi?.status === "Terminé" || isBilanN1Client(item);
  }).length;

  const missionsEnCours = clientsSansN1.filter((item) => {
    const suivi = item.suiviJuridique?.[0];
    return suivi?.status !== "Terminé" && !isBilanN1Client(item);
  }).length;

  const missionsAfaire = clientsSansN1.filter((item) => {
    const suivi = item.suiviJuridique?.[0];
    return suivi?.status === "A faire" && !isBilanN1Client(item);
  }).length;

  const totalChecked = [
    formData?.annuelsComplet,
    formData?.resultatUniquement,
  ].filter(Boolean).length;

  const activeFilters = filterRows
    .filter((f) => f.selectedValues?.length)
    .map((f) => [f.column, f.selectedValues]);

  const activeFilterCount = activeFilters.length;

  const handleClearAllFilters = () => {
    setFilterRows([{ column: "formeSociale", selectedValues: [] }]);
  };

  // Groupements (contacts Annuaire liés) : un groupement n'est affiché comme
  // tel que s'il est réellement partagé par au moins 2 dossiers — sinon le
  // client est traité comme un client normal, sans en-tête de groupe (même
  // règle que Portefeuille.js).
  const groupedByAnnuaire = {};
  const clientsSansGroupementAGO = [];
  tableClients.forEach((client) => {
    const ann = client.annuaires?.[0];
    if (ann) {
      if (!groupedByAnnuaire[ann.id]) {
        groupedByAnnuaire[ann.id] = { annuaireId: ann.id, clients: [] };
      }
      groupedByAnnuaire[ann.id].clients.push(client);
    } else {
      clientsSansGroupementAGO.push(client);
    }
  });
  Object.keys(groupedByAnnuaire).forEach((annuaireId) => {
    if (groupedByAnnuaire[annuaireId].clients.length < 2) {
      clientsSansGroupementAGO.push(...groupedByAnnuaire[annuaireId].clients);
      delete groupedByAnnuaire[annuaireId];
    }
  });
  const agoRowItems = [
    ...Object.values(groupedByAnnuaire).map((group) => ({
      type: "group",
      name: getGroupementLabel(group.annuaireId, group.clients[0]?.annuaires?.[0]),
      annuaireId: group.annuaireId,
      clients: group.clients,
    })),
    ...clientsSansGroupementAGO.map((client) => ({
      type: "client",
      name: client.nom,
      client,
    })),
  ].sort((a, b) =>
    a.name.trim().localeCompare(b.name.trim(), "fr", { sensitivity: "base" })
  );

  if (loading)
    return (
      <div>
        <div className="flex items-center justify-between gap-4 mb-5 mt-8 mr-2">
          <div className="h-9 w-64 rounded-md bg-slate-200 animate-pulse" />
          <div className="flex items-center gap-5">
            <div className="h-9 w-20 rounded-md bg-slate-200 animate-pulse" />
            <div className="h-9 w-20 rounded-md bg-slate-200 animate-pulse" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-5">
          <div className="h-20 rounded-xl bg-slate-200 animate-pulse" />
          <div className="h-20 rounded-xl bg-slate-200 animate-pulse" />
        </div>
        <div className="mt-6 w-full overflow-x-auto border border-slate-200 rounded-lg shadow-sm">
          <table className="w-full" style={{ fontSize: "0.72rem" }}>
            <thead>
              <tr className="bg-[#6e1a36]">
                {[
                  "Dossier",
                  "Statuts bilan",
                  "Status",
                  "Perte capitaux",
                  "Dépôt greffe",
                  "Récipissé",
                  "Dividendes",
                  "",
                ].map((col, i) => (
                  <th key={i} className="px-2 py-3.5 text-left">
                    <div
                      className="h-3 rounded bg-[#ffffff33] animate-pulse"
                      style={{ width: col ? "80%" : "24px" }}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {Array.from({ length: 8 }).map((_, i) => (
                <tr key={i} className="bg-white">
                  <td className="px-2 py-3">
                    <div className="h-3 rounded bg-slate-200 animate-pulse w-36" />
                  </td>
                  <td className="px-2 py-3">
                    <div className="h-5 w-20 rounded-full bg-slate-200 animate-pulse" />
                  </td>
                  <td className="px-2 py-3">
                    <div className="h-5 w-16 rounded-full bg-slate-200 animate-pulse" />
                  </td>
                  {Array.from({ length: 4 }).map((__, j) => (
                    <td key={j} className="px-2 py-3 text-center">
                      <div className="h-4 w-4 rounded-full bg-slate-200 animate-pulse mx-auto" />
                    </td>
                  ))}
                  <td className="px-2 py-3">
                    <div className="h-6 w-14 rounded-md bg-slate-200 animate-pulse" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );

  return (
    <div>
      {!selectedClient && (
        <>
          <div className="flex items-center justify-between gap-4 mb-5 mt-8 mr-2">
            <div className="relative flex-1 max-w-sm">
              <IoIosSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="text"
                placeholder="Filtrer par nom du dossier..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-9 h-9 w-full rounded-md bg-slate-50 border border-slate-200 text-sm focus:bg-white focus:outline-none"
              />
            </div>
            <div className="flex items-center gap-5">
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                className="border border-slate-300 rounded-md 
                              h-9 px-2 text-xs leading-tight w-20
                              bg-white"
              >
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <button
                onClick={() => setShowFilterOverlay(!showFilterOverlay)}
                className={`flex items-center gap-2 h-9 px-3 rounded-md font-semibold text-sm bg-white text-black border border-slate-300 hover:bg-slate-50`}
              >
                <CiFilter className="w-3 h-3" />
                Filtrer
              </button>
            </div>
            {showFilterOverlay && (
              <div
                ref={overlayRef}
                className="fixed top-[40%] left-[65%] -translate-x-1/2 bg-white border border-slate-200 rounded-lg p-4 shadow-lg z-50 w-2/5 max-h-[80vh] overflow-y-auto"
              >
                <div className="flex justify-between mb-2">
                  <p className="font-semibold">Filtres avancés</p>
                  <button
                    className="text-sm text-slate-600 hover:text-slate-800"
                    onClick={handleResetFilters}
                  >
                    Réinitialiser
                  </button>
                </div>

                {filterRows.map((filter, index) => (
                  <div key={index} className="mb-3">
                    <div className="flex items-center justify-between mb-1">
                      <select
                        value={filter.column}
                        onChange={(e) =>
                          handleFilterChange(index, "column", e.target.value)
                        }
                        className="border border-slate-200 rounded-md p-1 text-sm"
                      >
                        {Object.keys(uniqueValues).map((col) => (
                          <option key={col} value={col}>
                            {col}
                          </option>
                        ))}
                      </select>
                      <button
                        onClick={() => handleRemoveFilter(index)}
                        className="text-sm text-red-600 hover:text-red-800"
                      >
                        - Supprimer
                      </button>
                    </div>
                    <div className="flex flex-col ml-2">
                      {uniqueValues[filter.column]?.map((value) => (
                        <label key={value}>
                          <input
                            type="checkbox"
                            checked={filter.selectedValues.includes(value)}
                            onChange={() =>
                              handleCheckboxValueChange(index, value)
                            }
                          />
                          {value || "(vide)"}
                        </label>
                      ))}
                    </div>
                  </div>
                ))}

                <button
                  className="text-sm text-slate-700 hover:text-slate-900 mt-2"
                  onClick={handleAddFilter}
                >
                  + Ajouter filtre
                </button>
              </div>
            )}
          </div>

          {/* 2 cartes stats AGO */}
          <div className="grid grid-cols-2 gap-4 mb-5">
            <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm flex items-center gap-4">
              <div className="w-10 h-10 bg-[#e5ebfa] rounded-lg flex items-center justify-center border border-slate-100">
                <ChartSpline className="text-[#2c4fa1] w-5 h-5 font-light" />
              </div>
              <div>
                <p className="text-xs text-[#8d7b83] mb-0.5 font-medium m-0">
                  AGO en cours
                </p>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-2xl font-bold text-slate-900">
                    {missionsEnCours}
                  </span>
                  <span className="text-base text-slate-400 font-medium">
                    / {clientsSansN1.length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm flex items-center gap-4">
              <div className="w-10 h-10 bg-[#fbe3e3] rounded-lg flex items-center justify-center border border-red-100">
                <AlertCircle className="w-5 h-5 text-[#ba4848]" />
              </div>
              <div>
                <p className="text-xs text-[#8d7b83] mb-0.5 font-medium m-0">
                  AGO en retard
                </p>
                <span className="text-2xl font-bold text-slate-900">
                  {missionsAfaire}
                </span>
              </div>
            </div>
          </div>

          {/* Répartition par état AGO */}
          {(() => {
            const agoStatusConfig = {
              "En attente bilan": { dot: "#94a3b8", filter: "attentebilan" },
              "A faire": { dot: "#8b6a0f", filter: "afaire" },
              Rédaction: { dot: "#2c4fa1", filter: "redaction" },
              Supervision: { dot: "#2c4fa1", filter: "supervision" },
              Signature: { dot: "#8b6a0f", filter: "signature" },
              Formalités: { dot: "#2c4fa1", filter: "formalites" },
              Terminé: { dot: "#2a6d3c", filter: "termine" },
            };
            const knownAgoStatuses = [
              "A faire",
              "Rédaction",
              "Supervision",
              "Signature",
              "Formalités",
              "Terminé",
            ];
            const agoStatuses = Object.keys(agoStatusConfig);
            const grouped = {};
            agoStatuses.forEach((s) => {
              grouped[s] = 0;
            });
            clientsSansN1.forEach((item) => {
              const s = item.suiviJuridique?.[0]?.status;
              if (isBilanN1Client(item)) grouped["Terminé"]++;
              else if (s && knownAgoStatuses.includes(s)) grouped[s]++;
              else grouped["En attente bilan"]++;
            });
            return (
              <div className="bg-white rounded-xl border border-slate-100 shadow-sm p-5 mb-5">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-2 m-0">
                    <Scale className="w-4 h-4" /> Répartition par état
                  </h3>
                  <div className="flex items-center gap-2">
                    {activeStatFilter !== "all" && (
                      <button
                        onClick={() => setActiveStatFilter("all")}
                        className="text-xs text-slate-400 hover:text-slate-700 underline"
                      >
                        Tout afficher
                      </button>
                    )}
                    <span className="text-xs text-slate-400">
                      {clientsSansN1.length} dossiers
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-7 gap-3">
                  {agoStatuses.map((status) => {
                    const count = grouped[status];
                    const config = agoStatusConfig[status];
                    const isActive = activeStatFilter === config.filter;
                    return (
                      <button
                        key={status}
                        onClick={() =>
                          setActiveStatFilter(isActive ? "all" : config.filter)
                        }
                        className="rounded-lg px-3 pt-2.5 pb-3 relative overflow-hidden text-left transition-all"
                        style={{
                          backgroundColor: "#faf7f4",
                          border: isActive
                            ? `2px solid ${config.dot}`
                            : "1px solid #e8e0d8",
                          boxShadow: isActive
                            ? `0 0 0 2px ${config.dot}22`
                            : "none",
                        }}
                      >
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center gap-1.5 flex-1 min-w-0">
                            <div
                              className="w-2 h-2 rounded-full flex-shrink-0"
                              style={{ backgroundColor: config.dot }}
                            />
                            <span className="text-xs text-slate-600 leading-tight">
                              {status}
                            </span>
                          </div>
                          <span className="text-base font-bold ml-2 flex-shrink-0 text-slate-900">
                            {count}
                          </span>
                        </div>
                        <div
                          className="h-0.5 w-6 rounded-full"
                          style={{ backgroundColor: config.dot }}
                        />
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {activeFilterCount > 0 && (
            <div className="w-[98%] mt-4 px-3 py-2 flex items-center gap-5 text-xs text-slate-700">
              {/* 🧮 Infos filtres */}
              <div className="flex flex-wrap gap-x-3 gap-y-1 items-center">
                <span className="font-medium px-3 py-2 bg-slate-50 border border-slate-200 rounded-md">
                  {activeFilterCount} filtre{activeFilterCount > 1 ? "s" : ""}{" "}
                  actif
                  {activeFilterCount > 1 ? "s" : ""}
                </span>

                {activeFilters.map(([key, values]) => (
                  <span key={key} className="text-slate-600">
                    <strong>
                      {TABLE_FILTERABLE_COLUMNS[key]?.label || key} :
                    </strong>{" "}
                    {values.join(", ")}
                  </span>
                ))}
              </div>

              {/* ❌ Tout effacer */}
              <button
                onClick={handleClearAllFilters}
                className="text-slate-500 hover:text-[#9B1B5D] text-xs transition-colors px-3 py-2 bg-slate-50 border border-slate-200 rounded-md"
              >
                Tout effacer
              </button>
            </div>
          )}

          <table
            className="mt-6 border border-slate-200 w-full rounded-lg shadow-sm overflow-hidden"
            style={{ fontSize: "0.72rem", tableLayout: "fixed" }}
          >
            <colgroup>
              <col style={{ width: "18%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "13%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "14%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr className="bg-[#6e1a36]  text-xs p-5">
                <th className="px-2 py-3.5 text-white font-semibold text-left">
                  Dossier
                </th>

                <FilterableTableTh
                  columnKey="statusBilan"
                  label="Statuts bilan"
                />
                <FilterableTableTh columnKey="status" label="Status" />
                <FilterableTableTh
                  columnKey="capitauxPropresReconstitue"
                  label="Perte capitaux propres"
                />
                <FilterableTableTh
                  columnKey="depotGreffecheck"
                  label="Dépôt greffe"
                />
                <FilterableTableTh
                  columnKey="recepissecheck"
                  label="Récipissé dépôt"
                />
                <FilterableTableTh
                  columnKey="sd2777check"
                  label="Dividendes / 2777-SD"
                />

                <th className="px-2 py-1.5 text-white font-semibold text-left"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {agoRowItems
                .map((item) => {
                  // ============================
                  // 📁 CAS GROUPEMENT
                  // ============================
                  if (item.type === "group") {
                    const isOpen = openGroups[item.annuaireId] ?? true;

                    return (
                      <React.Fragment key={`group-${item.annuaireId}`}>
                        <tr>
                          <td
                            colSpan="16"
                            className="px-2 py-1.5 font-semibold uppercase text-slate-700 cursor-pointer"
                            onClick={() =>
                              setOpenGroups((prev) => ({
                                ...prev,
                                [item.annuaireId]: !isOpen,
                              }))
                            }
                          >
                            <div className="flex items-center gap-2">
                              <ChevronDown
                                size={14}
                                className={`transition-transform duration-200 ${
                                  isOpen ? "rotate-0" : "-rotate-90"
                                }`}
                              />
                              {item.name}
                              <span className="text-slate-500 normal-case">
                                ({item.clients.length})
                              </span>
                            </div>
                          </td>
                        </tr>

                        {/* Clients du groupement */}
                        {isOpen &&
                          item.clients
                            .sort((a, b) =>
                              a.nom.localeCompare(b.nom, "fr", {
                                sensitivity: "base",
                              })
                            )
                            .map((client) => {
                              const suivi =
                                client.suiviJuridique.length > 0
                                  ? client.suiviJuridique[0]
                                  : null;

                              const suiviBilan =
                                client.suiviBilans.length > 0
                                  ? client.suiviBilans[0]
                                  : null;

                              const isFirstBilanN1 =
                                suiviBilan?.status === "1er bilan en N+1";
                              const isGreyedOut =
                                isFirstBilanN1 ||
                                suivi?.status === "Fin de mission";

                              return (
                                <tr
                                  key={suivi ? suivi.id : client.id}
                                  data-client-id={client.id}
                                  onClick={() =>
                                    showOverlayDetails(
                                      client,
                                      client.suiviJuridique?.[0] || {
                                        annees: selectedYear,
                                      },
                                      client.suiviBilans?.[0] || {
                                        annees: selectedYear,
                                      }
                                    )
                                  }
                                  className={`cursor-pointer ${
                                    estBloque(client) ? "ligne-bloquee" : isGreyedOut ? "opacity-40 grayscale" : ""
                                  } ${
                                    animatingId === client.id
                                      ? "todo-row-validating"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor: isGreyedOut
                                      ? "#f8fafc"
                                      : suivi
                                      ? getRowColor(suivi.status)
                                      : "transparent",
                                  }}
                                >
                                  <td
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      showClientDetails(client);
                                    }}
                                    className="px-2 py-3.5 font-medium text-slate-900 cursor-pointer hover:text-[#9B1B5D] transition-colors relative overflow-visible"
                                  >
                                    {animatingId === client.id && (
                                      <span className="todo-done-badge">
                                        ✓ Terminé !
                                      </span>
                                    )}
                                    {client.nom}
{estBloque(client) && <BadgeBloque />}
                                  </td>

                                  <td className="px-2 py-1.5 text-slate-600">
                                    {suiviBilan ? suiviBilan.status : " "}
                                  </td>

                                  <td className="px-2 py-1.5 text-slate-600">
                                    {isFirstBilanN1
                                      ? "1er bilan en N+1"
                                      : suivi
                                      ? suivi.status
                                      : " "}
                                  </td>

                                  {[
                                    "capitauxPopresReconstitue",
                                    "depotGreffecheck",
                                    "recepissecheck",
                                    "sd2777check",
                                  ].map((field) => (
                                    <td
                                      key={field}
                                      className="px-2 py-1.5 text-center"
                                    >
                                      <div className="flex justify-center">
                                        {suivi?.[field] === true ? (
                                          <div className="w-3 h-3 rounded-full bg-emerald-500 shadow shadow-emerald-500/50" />
                                        ) : (
                                          <div className="w-3 h-3 rounded-full bg-slate-200" />
                                        )}
                                      </div>
                                    </td>
                                  ))}

                                  <td
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleEditClick(
                                        client,
                                        client.suiviJuridique[0] || {
                                          annees: selectedYear,
                                        }
                                      );
                                    }}
                                  >
                                    <button className="flex items-center gap-1 text-xs px-2 py-1 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-all bg-slate-50">
                                      <ExternalLink className="w-3 h-3" />
                                      <span>Ouvrir</span>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                      </React.Fragment>
                    );
                  }

                  // ============================
                  // 👤 CAS CLIENT SANS GROUPEMENT
                  // ============================
                  const client = item.client;
                  const suivi =
                    client.suiviJuridique.length > 0
                      ? client.suiviJuridique[0]
                      : null;

                  const suiviBilan =
                    client.suiviBilans.length > 0
                      ? client.suiviBilans[0]
                      : null;

                  const isFirstBilanN1 =
                    suiviBilan?.status === "1er bilan en N+1";
                  const isGreyedOut =
                    isFirstBilanN1 || suivi?.status === "Fin de mission";

                  return (
                    <tr
                      key={client.id}
                      data-client-id={client.id}
                      onClick={() =>
                        showOverlayDetails(
                          client,
                          client.suiviJuridique?.[0] || {
                            annees: selectedYear,
                          },
                          client.suiviBilans?.[0] || {
                            annees: selectedYear,
                          }
                        )
                      }
                      className={`cursor-pointer ${
                        estBloque(client) ? "ligne-bloquee" : isGreyedOut ? "opacity-40 grayscale" : ""
                      } ${
                        animatingId === client.id ? "todo-row-validating" : ""
                      }`}
                      style={{
                        backgroundColor: isGreyedOut
                          ? "#f8fafc"
                          : suivi
                          ? getRowColor(suivi.status)
                          : "transparent",
                      }}
                    >
                      <td
                        onClick={(e) => {
                          e.stopPropagation();
                          showClientDetails(client);
                        }}
                        className="px-2 py-3.5 font-medium text-slate-900 cursor-pointer hover:text-[#9B1B5D] transition-colors relative overflow-visible"
                      >
                        {animatingId === client.id && (
                          <span className="todo-done-badge">✓ Terminé !</span>
                        )}
                        {client.nom}
{estBloque(client) && <BadgeBloque />}
                      </td>

                      <td className="px-2 py-1.5 text-slate-600">
                        {suiviBilan ? suiviBilan.status : " "}
                      </td>

                      <td className="px-2 py-1.5 text-slate-600">
                        {isFirstBilanN1
                          ? "1er bilan en N+1"
                          : suivi
                          ? suivi.status
                          : " "}
                      </td>

                      <td className="px-2 py-1.5 text-slate-600">
                        {suivi
                          ? renderBool(suivi.capitauxPopresReconstitue)
                          : " "}
                      </td>

                      {[
                        "depotGreffecheck",
                        "recepissecheck",
                        "sd2777check",
                      ].map((field) => (
                        <td key={field} className="px-2 py-1.5 text-center">
                          <div className="flex justify-center">
                            {suivi?.[field] === true ? (
                              <div className="w-3 h-3 rounded-full bg-emerald-500 shadow shadow-emerald-500/50" />
                            ) : (
                              <div className="w-3 h-3 rounded-full bg-slate-200" />
                            )}
                          </div>
                        </td>
                      ))}

                      <td
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditClick(
                            client,
                            client.suiviJuridique[0] || {
                              annees: selectedYear,
                            }
                          );
                        }}
                      >
                        <button className="flex items-center gap-1 text-xs px-2 py-1 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-all bg-slate-50">
                          <ExternalLink className="w-3 h-3" />
                          <span>Ouvrir</span>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          {activeColumnFilter && (
            <div
              ref={filterRef}
              style={{
                position: "fixed",
                top: columnFilterPosition.top,
                left: columnFilterPosition.left,
                zIndex: 10000,
              }}
              className="bg-white border border-slate-200 rounded-lg shadow-lg w-64 max-h-72 flex flex-col"
            >
              <div className="px-3 py-2 border-b font-semibold text-sm">
                {activeColumnFilter &&
                  TABLE_FILTERABLE_COLUMNS[activeColumnFilter]?.label}
              </div>
              <div className="flex-1 overflow-y-auto px-3 py-2">
                {" "}
                {uniqueColumnValues[activeColumnFilter]?.map((value) => (
                  <div
                    key={String(value)}
                    className="flex items-center gap-2 cursor-pointer hover:bg-slate-100 px-2 py-1 rounded"
                    onClick={() => {
                      setFilterRows((prev) => {
                        const existing = prev.find(
                          (f) => f.column === activeColumnFilter
                        );

                        if (existing) {
                          const updated = prev.map((f) =>
                            f.column === activeColumnFilter
                              ? {
                                  ...f,
                                  selectedValues: f.selectedValues.includes(
                                    value
                                  )
                                    ? f.selectedValues.filter(
                                        (v) => v !== value
                                      )
                                    : [...f.selectedValues, value],
                                }
                              : f
                          );
                          return updated;
                        }

                        return [
                          ...prev,
                          {
                            column: activeColumnFilter,
                            selectedValues: [value],
                          },
                        ];
                      });
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={
                        filterRows
                          .find((f) => f.column === activeColumnFilter)
                          ?.selectedValues.includes(value) || false
                      }
                      readOnly
                    />
                    <span>
                      {typeof value === "boolean"
                        ? value
                          ? "Oui"
                          : "Non"
                        : value}
                    </span>
                  </div>
                ))}
              </div>

              {/* 🎯 Actions */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "8px 10px",
                  borderTop: "1px solid #eee",
                }}
              >
                <button
                  onClick={() => handleResetColumnFilter(activeColumnFilter)}
                  style={{
                    fontSize: "0.8rem",
                    padding: "4px 8px",
                    border: "none",
                    borderRadius: "6px",
                    background: "#f0f0f0",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#e0e0e0")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#f0f0f0")
                  }
                >
                  Réinitialiser
                </button>

                <button
                  onClick={() => setActiveColumnFilter(null)}
                  style={{
                    fontSize: "0.8rem",
                    padding: "4px 8px",
                    border: "none",
                    borderRadius: "6px",
                    background: "#9B1B5D",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#7A1548")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#9B1B5D")
                  }
                >
                  Appliquer
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {showCreateTodo && (
        <div className="overlayAC">
          <div
            className="inoverlayLead"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <button
              className="close-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowCreateTodo(false);
              }}
              style={{
                position: "absolute",
                top: "40px",
                right: "420px",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                fontWeight: "bold",
                color: "#999",
                cursor: "pointer",
                transition: "color 0.3s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#555")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
              aria-label="Fermer"
            >
              &times;
            </button>

            <CreateTodo
              onBack={() => setShowCreateTodo(false)}
              item={selectedClient}
              itemtype={itemtype}
              suiviJuridiqueId={selectedClient?.suivi?.id}
              onClose={() => setShowCreateTodo(false)}
            />
          </div>
        </div>
      )}

      {overlayData && (
        <div className="overlayAC">
          <div className="inoverlayMS">
            <button
              className="close-button"
              onClick={() => setOverlayData(null)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "transparent",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              <button
                aria-label="Fermer"
                className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </button>
            <OverlayDetails
              overlayData={overlayData}
              formatDateWithoutYear={formatDateWithoutYear}
              renderBool={renderBool}
              selectedYear={selectedYear}
            />
          </div>
        </div>
      )}

      {selectedClient && (
        <div>
          <div>
            <div
              style={{
                display: "flex",
                width: "100%",
                marginTop: "2%",
                overflowX: "hidden",
              }}
            >
              <div className="w-1/4">
                <div className="cursor-pointer shadow-lg px-10 py-4 w-[90%] ml-3 rounded-lg mb-4 flex flex-col justify-center border-slate-200 hover:shadow-md hover:border-slate-200 bg-white">
                  <div
                    onClick={() => setSelectedClient(null)}
                    className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 mb-4"
                  >
                    <ArrowLeft className="w-4 h-4" />
                    Retour aux dossiers
                  </div>
                  <div>
                    <h1 className="text-lg font-bold text-slate-900 mb-1">
                      {selectedClient.client.nom}
                    </h1>
                    <p className="text-sm text-slate-500">
                      Exercice {selectedYear}
                    </p>
                  </div>
                </div>

                <br />
                <div className="space-y-2">
                  {sections.map((section) => {
                    const isActive = activeSection === section;
                    const Icon = sectionIcons[section];

                    return (
                      <button
                        key={section}
                        onClick={() => setActiveSection(section)}
                        className={`w-[90%] ml-4 flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-left bg-white
          ${
            isActive
              ? "bg-[#840040]/10 ring-2 ring-[#840040]"
              : "hover:bg-slate-50"
          }`}
                      >
                        <div
                          className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0
            ${isActive ? "bg-[#840040]/10" : "bg-slate-100"}`}
                        >
                          <Icon
                            className={`w-5 h-5
              ${isActive ? "text-[#840040]" : "text-slate-400"}`}
                          />
                        </div>

                        <span
                          className={`text-sm font-medium
            ${isActive ? "text-[#840040]" : "text-slate-600"}`}
                        >
                          {section}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="w-full pl-10">
                <div className="flex justify-space items-center gap-3 mb-0">
                  {activeSection && (
                    <div className="mb-4 w-2/3 flex items-center gap-3 px-4 py-3 ">
                      <div className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0 bg-[#840040]/10">
                        {React.createElement(sectionIcons[activeSection], {
                          className: "w-7 h-7 text-[#840040]",
                        })}
                      </div>
                      <span className="text-xl font-semibold text-[#000]">
                        {activeSection}
                      </span>
                    </div>
                  )}
                  <div className="flex  gap-3 mb-6">
                    <select
                      className={`
                                            px-4 py-2 rounded-md border text-xs 
                                            w-64 h-10
                                            ${
                                              formData.status === "A faire"
                                                ? "#fff8dc" // jaune très clair
                                                : formData.status ===
                                                  "Rédaction"
                                                ? "#fff8dc" // kaki clair
                                                : formData.status ===
                                                  "Supervision"
                                                ? "#f0e68c" // kaki clair
                                                : formData.status ===
                                                  "Signature"
                                                ? "#ffd700" // or
                                                : formData.status ===
                                                  "Formalités"
                                                ? "#DCEEFF" // vert clair
                                                : formData.status === "Terminé"
                                                ? "#90ee90" // vert franc
                                                : "white"
                                            }
                                          `}
                      value={formData.status || " "}
                      onChange={(e) => handleChange("status", e.target.value)}
                    >
                      <option value=" ">-- Sélectionner --</option>
                      <option value="A faire">A faire</option>
                      <option value="Rédaction">Rédaction</option>
                      <option value="Supervision">Supervision</option>
                      <option value="Signature">Signature</option>
                      <option value="Formalités">Formalités</option>
                      <option value="Terminé">Terminé</option>
                      <option value="1er bilan en N+1">1er bilan en N+1</option>
                      <option value="Fin de mission">Fin de mission</option>
                    </select>
                    <button
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                      className="flex items-center gap-2 h-10 px-5 rounded-md font-semibold text-sm bg-[#840040] hover:bg-[#6e1a36] text-white disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Save className="w-4 h-4" />
                      {isSubmitting ? "Mise à jour..." : "Enregistrer"}
                    </button>

                    <button
                      onClick={() => setShowCreateTodo(true)}
                      className={`flex items-center gap-2 h-10 px-3 rounded-md font-semibold text-sm bg-white text-black border border-slate-300 hover:bg-slate-50`}
                    >
                      Todo
                    </button>
                  </div>
                </div>

                {activeSection === "Généralités" && (
                  <div className="bg-white">
                    <div className="bg-gradient-to-r from-[#840040]/5 to-transparent border-b py-5 px-4 mb-4">
                      <h3 className="font-semibold text-sm text-slate-900 m-0">
                        Généralités Informatio
                      </h3>
                    </div>
                    <div style={{ display: "flex", gap: "21.75%" }}>
                      <p>
                        <span
                          style={{
                            color: "grey",
                          }}
                        >
                          Forme Juridique :{" "}
                        </span>
                        {selectedClient.client.formeSociale}
                      </p>{" "}
                      <div
                        style={{
                          display: "flex",
                          gap: "2%",
                          alignItems: "center",
                          width: "40%",
                        }}
                      >
                        <span
                          style={{
                            color: "grey",
                          }}
                        >
                          Holding :
                        </span>
                        <p>{Checkbool(selectedClient.client.holding)}</p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "8%",
                        marginTop: "0.5%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "2%",
                          alignItems: "center",
                          width: "27%",
                        }}
                      >
                        <span
                          style={{
                            color: "grey",
                          }}
                        >
                          Associé Unique ?
                        </span>
                        <div className="flex items-center">
                          <div
                            className={`w-4 h-4 rounded-full border flex items-center justify-center
      ${
        ["EURL", "SASU"].includes(selectedClient.client.formeSociale?.[0])
          ? "border-emerald-600"
          : "border-slate-300"
      }
    `}
                          >
                            {["EURL", "SASU"].includes(
                              selectedClient.client.formeSociale?.[0]
                            ) && (
                              <div className="w-2 h-2 rounded-full bg-emerald-600" />
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "2%",
                          alignItems: "center",
                          width: "70%",
                        }}
                      >
                        <span
                          style={{
                            color: "grey",
                          }}
                        >
                          Si oui, l'associé unique est personne physique est
                          dirigeant ?
                        </span>
                        <p>
                          {Checkbool(selectedClient.client.personnePhysique)}
                        </p>
                      </div>
                    </div>
                    <hr style={{ margin: "20px 0" }} />
                    <h4>Convention</h4>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "0.4fr 1fr",
                        gap: "1%",
                        marginTop: "1%",
                      }}
                    >
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        Rémunération à approuver :
                      </span>
                      <p>
                        {Checkbool(
                          selectedClient.client.suiviBilans.remuneration
                        )}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "0.4fr 1fr",
                        gap: "1%",
                        marginTop: "0.5%",
                      }}
                    >
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        Convention réglementées à approuver :
                      </span>
                      <p>
                        {Checkbool(
                          selectedClient.client.suiviBilans.convention
                        )}
                      </p>
                    </div>

                    <hr style={{ margin: "20px 0" }} />
                    <h4>Affectation du résultat</h4>
                    <div
                      style={{
                        display: "flex",
                        gap: "0.5%",
                        marginTop: "1%",
                        alignItems: "center",
                      }}
                    >
                      <p>
                        {" "}
                        <span
                          style={{
                            color: "grey",
                          }}
                        >
                          - Résevre légale
                        </span>{" "}
                      </p>{" "}
                      <p>
                        {CheckboolS(
                          selectedClient.client.suiviBilans.reserveLegale
                        )}
                      </p>
                      <p>
                        {selectedClient.client.suiviBilans
                          .reserveLegaleMontant ||
                          "\u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0"}{" "}
                        €
                      </p>
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp;
                      <p>
                        {" "}
                        {CheckboolS(selectedClient.client.suiviBilans.dotee)}
                      </p>
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        Convention réglementées à approuver :
                      </span>
                    </div>
                    <p style={{ marginTop: "1%" }}> - Dividendes</p>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "0.5%",
                        marginLeft: "3%",
                        gap: "2%",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        Dispense prélèvement forfaitaire non libératoire :
                      </span>
                      <p>
                        {CheckboolS(selectedClient.client.suiviBilans.dispense)}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "0.5%",
                        marginLeft: "3%",
                        gap: "2%",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        Si SARL, montannt sousmis à cotisations sociales :
                      </span>
                      <p>{selectedClient.client.suiviBilans.sarl} €</p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "0.5%",
                        gap: "2%",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        - Autres
                      </span>
                      <p>{selectedClient.client.suiviBilans.aurtres} </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "0.5%",
                        gap: "2%",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "grey",
                        }}
                      >
                        - Report à nouveau
                      </span>
                      <p>
                        {CheckboolS(selectedClient.client.suiviBilans.report)}
                      </p>
                    </div>
                    <div className="bg-gradient-to-r from-[#840040]/5 to-transparent border-b py-5 px-4 mb-4 mt-4">
                      <h3 className="font-semibold text-sm text-slate-900 m-0">
                        Annexes
                      </h3>
                    </div>

                    <div>
                      {/* En-tête */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 0.5fr 0.5fr 0.5fr",
                          textAlign: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <span></span>
                        <span>OK</span>
                        <span>Dispense</span>
                        <span>N/A</span>
                      </div>

                      {[
                        { label: "Comptes Annuel", key: "comptesAnnuel" },
                        { label: "Courrier", key: "courrier" },
                        { label: "Feuille Présence", key: "feuillePresence" },
                        {
                          label: "Texte des Résolutions",
                          key: "texteDesResolution",
                        },
                        { label: "Rapport Gestion", key: "rapportGestion" },
                        {
                          label: "Rapport Convention",
                          key: "rapportConvetion",
                        },
                        { label: "Rapport Conseil", key: "rapportConseil" },
                        { label: "Rapport CAC", key: "rapportCAC" },
                        { label: "Procès Verbal", key: "procésVerbal" },
                        { label: "Extrait PV", key: "extraitPV" },
                        {
                          label: "Déclaration Confidentialité",
                          key: "declarationConfidentialite",
                        },
                        { label: "Pouvoir", key: "pouvoir" },
                      ].map((item) => {
                        const options = ["OK", "Dispense", "N/A"];
                        const value = formData[item.key] || "";

                        return (
                          <div
                            key={item.key}
                            style={{
                              display: "grid",
                              gridTemplateColumns: "2fr 0.5fr 0.5fr 0.5fr",
                              alignItems: "center",
                              textAlign: "center",
                              marginBottom: "8px",
                            }}
                          >
                            <span style={{ textAlign: "left" }}>
                              {item.label}
                            </span>
                            {options.map((opt) => (
                              <input
                                key={opt}
                                type="checkbox"
                                checked={value === opt}
                                onChange={() => handleChange(item.key, opt)}
                              />
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {activeSection === "Commentaires" && (
                  <div className="space-y-4 overflow-hidden">
                    <div className="bg-gradient-to-r from-[#840040]/5 to-transparent p-4 rounded-xl border border-[#840040]/10 w-full mb-2">
                      <h3 className="font-semibold text-slate-900 mb-1">
                        Commentaire
                      </h3>
                      <p className="text-sm text-slate-600">
                        Commentaires juridiques AGO
                      </p>
                    </div>

                    <div className="space-y-3 overflow-y-auto pr-2">
                      {(() => {
                        const commentaires =
                          selectedClient.client.suiviJuridique.find(
                            (b) => b.annees === selectedYear
                          )?.commentaires || [];

                        const typeUnique = "Juridique AGO";

                        const commentairesFiltres = commentaires.filter(
                          (c) => c.type === typeUnique
                        );

                        const isOpen = true; // Toujours ouvert car un seul type

                        return (
                          <div className="border rounded-lg bg-white">
                            {/* Header du type */}
                            <button
                              onClick={() => {}}
                              className="w-full text-left p-3 flex justify-between items-center bg-slate-50 cursor-default"
                            >
                              <div className="flex items-center gap-2">
                                <span>{typeUnique}</span>
                                {commentairesFiltres.length > 0 && (
                                  <span className="text-xs bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full flex items-center gap-1">
                                    {commentairesFiltres.length} commentaires
                                  </span>
                                )}
                              </div>
                            </button>

                            {/* Contenu des commentaires */}
                            {isOpen && (
                              <div className="p-4 space-y-4 bg-slate-50 border-t">
                                {/* Formulaire d’ajout */}
                                <textarea
                                  placeholder={`Écrire un commentaire pour "${typeUnique}"...`}
                                  value={newCommentTexts[typeUnique] || ""}
                                  onChange={(e) =>
                                    setNewCommentTexts({
                                      ...newCommentTexts,
                                      [typeUnique]: e.target.value,
                                    })
                                  }
                                  className="w-full p-3 rounded-lg border border-slate-300 min-h-[80px] resize-none"
                                />
                                <button
                                  onClick={() =>
                                    handleAddComment(
                                      typeUnique,
                                      newCommentTexts[typeUnique],
                                      selectedClient,
                                      selectedYear,
                                      () => {},
                                      () =>
                                        setNewCommentTexts({
                                          ...newCommentTexts,
                                          [typeUnique]: "",
                                        }),
                                      setSelectedClient
                                    )
                                  }
                                  disabled={
                                    isAddingComment ||
                                    !(newCommentTexts[typeUnique] || "").trim()
                                  }
                                  className="w-full bg-[#840040] hover:bg-[#6b0033] disabled:opacity-40 disabled:cursor-not-allowed text-white py-2 rounded-lg flex items-center justify-center gap-2"
                                >
                                  {isAddingComment ? "Envoi..." : "Ajouter"}
                                </button>

                                {/* Liste des commentaires */}
                                <div className="space-y-3">
                                  {commentairesFiltres.length === 0 ? (
                                    <div className="text-center py-6 text-[#840040] opacity-50">
                                      Aucun commentaire pour ce cycle.
                                    </div>
                                  ) : (
                                    commentairesFiltres.map((c) => (
                                      <div
                                        key={c.id}
                                        className="bg-white rounded-lg p-3 border border-[#84004030]"
                                      >
                                        <div className="flex items-start gap-3">
                                          {/* Avatar */}
                                          <div
                                            className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold text-white flex-shrink-0"
                                            style={{
                                              backgroundColor: "#840040",
                                            }}
                                          >
                                            {(c.nomComplet || "A")[0]}
                                          </div>

                                          <div className="flex-1">
                                            {/* Header */}
                                            <div className="flex items-baseline justify-between gap-2 mb-1">
                                              <span className="font-semibold text-slate-800 text-sm">
                                                {c.nomComplet || "Anonyme"}
                                              </span>
                                              {c.createdAt && (
                                                <span
                                                  className="text-xs flex items-center gap-1"
                                                  style={{ color: "#840040" }}
                                                >
                                                  {new Date(
                                                    c.createdAt
                                                  ).toLocaleString("fr-FR")}
                                                </span>
                                              )}
                                            </div>

                                            {/* Commentaire */}
                                            <p className="text-sm text-slate-700 leading-relaxed">
                                              {c.commentaire}
                                            </p>

                                            {/* Bouton statut */}
                                            <button
                                              onClick={() =>
                                                handleToggleStatus(c.id)
                                              }
                                              className={`mt-2 px-3 py-1 rounded-full text-xs font-medium text-white transition ${
                                                toggledComments[c.id] ??
                                                c.status
                                                  ? "bg-gray-400"
                                                  : "bg-[#840040]"
                                              }`}
                                            >
                                              {toggledComments[c.id] ?? c.status
                                                ? "Vu"
                                                : "CRM"}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                )}

                {activeSection === "Confidentialité des comptes" && (
                  <div
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "12px",
                      marginTop: "10px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {/* HEADER */}
                    <div
                      onClick={() => setAnnexeOpen2(!annexeOpen2)}
                      className="hover:bg-slate-50 transition-colors cursor-pointer p-5 "
                      style={{ userSelect: "none" }}
                    >
                      <div className="flex items-center justify-between">
                        {/* Left: Chevron + Title */}
                        <div className="flex items-center gap-3">
                          <ChevronDown
                            size={20}
                            className="text-slate-400"
                            style={{
                              transform: annexeOpen2
                                ? "rotate(0deg)"
                                : "rotate(-90deg)",
                              transition: "transform 0.2s ease",
                            }}
                          />
                          <span className="text-base font-semibold">
                            Confidentialité des comptes
                          </span>
                        </div>

                        {/* Right: Counter + Icon */}
                        <div className="flex items-center gap-2">
                          {totalChecked >= 1 ? (
                            <div className="flex items-center gap-1">
                              <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                            </div>
                          ) : (
                            <div className="flex items-center gap-1">
                              <AlertTriangle className="w-5 h-5 text-amber-500" />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {annexeOpen2 && (
                      <div className="ml-10">
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            checked={formData.annuelsComplet || false}
                            onChange={(e) =>
                              handleChange("annuelsComplet", e.target.checked)
                            }
                            className="w-4 h-4 accent-indigo-600"
                          />
                          <label className="text-sm font-medium">
                            Comptes annuels complets (microentreprises)
                          </label>
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "100%",
                            marginLeft: "2%",
                          }}
                        >
                          <p>
                            - N'est pas une cociété mentionnée à l'article
                            L.123-16-2
                          </p>
                          <p>
                            - N'a pas pour activité la gestion des titres de
                            participations et de valeurs mobilières
                          </p>
                          <p>
                            - Micro-entreprises (L.123-16-1 et de l'article D.
                            123-200 1° Cide comm), ne sont pas dépassés 2 des 3
                            seuils suivants :{" "}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "100%",
                            marginLeft: "5%",
                          }}
                        >
                          <p>✓ Total du bilan : 450 000 euros</p>
                          <p>✓ Montant du chiffre d'affaires : 900 000 euros</p>
                          <p>
                            ✓ Nombre moyen de salaries employés au cours de
                            l'exercice : 10
                          </p>
                        </div>
                        <div className="flex items-center gap-2 mt-5">
                          <input
                            type="checkbox"
                            checked={formData.resultatUniquement || false}
                            onChange={(e) =>
                              handleChange(
                                "resultatUniquement",
                                e.target.checked
                              )
                            }
                            className="w-4 h-4 accent-indigo-600"
                          />
                          <label className="text-sm font-medium">
                            Comptes de résultat uniquement
                          </label>
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "100%",
                            marginLeft: "2%",
                          }}
                        >
                          <p>
                            - Petite entreprises (L. 123-16 autre que L.
                            123-16-2), ne sont pas dépassés 2 des 3 seuils
                            suivants :{" "}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "100%",
                            marginLeft: "5%",
                          }}
                        >
                          <p>✓ Total du bilan : 7 500 000 euros</p>
                          <p>
                            ✓ Montant du chiffre d'affaires : 15 000 000 euros
                          </p>
                          <p>
                            ✓ Nombre moyen de salaries employés au cours de
                            l'exercice : 50
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {activeSection === "Historique" && (
                  <div className="bg-white p-4">
                    {/* Header historique */}
                    <div className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-slate-900 mb-3">
                      <div className="w-2 h-2 rounded-full bg-[#8B1538]"></div>
                      Événements cabinet
                    </div>

                    {/* Liste des historiques */}
                    {selectedClient.suivi.historiques &&
                    selectedClient.suivi.historiques.length > 0 ? (
                      selectedClient.suivi.historiques.map((histo) => (
                        <div
                          key={histo.id}
                          className="relative pl-5 mb-4 border-l-2 border-slate-300"
                        >
                          {/* Pastille */}
                          <div className="absolute -left-1 top-0 w-2.5 h-2.5 rounded-full bg-[#8B1538] border-2 border-white"></div>

                          {/* Contenu */}
                          <div className="bg-blue-100 border border-slate-300 rounded-lg p-3">
                            <div className="flex justify-between items-start mb-1">
                              <p className="text-sm font-semibold text-blue-800">
                                {histo.titre}
                              </p>
                              <span className="text-xs text-blue-800">
                                {formatDateWithoutYear(histo.createdAt)}
                              </span>
                            </div>
                            <p className="text-sm text-blue-900">
                              {histo.description}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="italic text-gray-400">
                        Aucun historique pour l'instant
                      </p>
                    )}
                  </div>
                )}

                {activeSection ===
                  "ART. L.223-42, R.223-36 / L.225648 R.225-166 CODE DU COMMERCE" && (
                  <div className="bg-white">
                    <div className="bg-gradient-to-r from-[#840040]/5 to-transparent border-b py-5 px-4 mb-4">
                      <h3 className="font-semibold text-sm text-slate-900 m-0">
                        {" "}
                        CODE DU COMMERCE{" "}
                      </h3>
                    </div>
                    <div
                      style={{
                        margin: "20px 0",
                        display: "flex",
                        gap: "1.5%",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: "10px",
                      }}
                    >
                      <label>
                        {" "}
                        Les capitaux propres sont devenues inférieurs à ½ du
                        capital durant l'exercice ?
                      </label>
                      <input
                        type="checkbox"
                        checked={formData.capitauxPropres || false}
                        onChange={(e) =>
                          handleChange("capitauxPropres", e.target.checked)
                        }
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "2%",
                        marginTop: "1.5%",
                        width: "100%",
                      }}
                    >
                      <p>Si pertes antérieures :</p>
                      <div style={{ width: "70%" }}>
                        <p>
                          <span
                            style={{
                              color: "grey",
                            }}
                          >
                            - Exercice ayant constaté la perte :{" "}
                          </span>
                          <input
                            type="text"
                            className="w-[50%] px-3 py-2 border border-slate-300 rounded text-sm"
                            value={formData.exercice || ""}
                            onChange={(e) =>
                              handleChange("exercice", e.target.value)
                            }
                          />
                        </p>
                        <div
                          style={{
                            display: "flex",
                            gap: "2%",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "2%",
                          }}
                        >
                          <span
                            style={{
                              color: "grey",
                            }}
                          >
                            - Les capitaux propres ont été reconstitué durant
                            l'exercice ?
                          </span>
                          <input
                            type="checkbox"
                            checked={formData.reserveLegaleMontant || false}
                            onChange={(e) =>
                              handleChange(
                                "reserveLegaleMontant",
                                e.target.checked
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeSection === "Formalités / Déclarations" && (
                  <div className="bg-white">
                    <div className="bg-gradient-to-r from-[#840040]/5 to-transparent border-b py-5 px-4 mb-4">
                      <h3 className="font-semibold text-sm text-slate-900 m-0">
                        Formalités / Déclarations
                      </h3>
                    </div>
                    <div className="grid grid-cols-[15%_5%_25%_5%_5%] items-center gap-2 mt-2">
                      <label>Dépôt Greffe</label>
                      <input
                        type="checkbox"
                        checked={formData.depotGreffecheck || false}
                        onChange={(e) =>
                          handleChange("depotGreffecheck", e.target.checked)
                        }
                        className="w-4 h-4"
                      />
                      <input
                        type="date"
                        value={
                          formData.depotGreffe
                            ? new Date(formData.depotGreffe)
                                .toISOString()
                                .slice(0, 16)
                            : ""
                        }
                        onChange={(e) =>
                          handleChange(
                            "depotGreffe",
                            e.target.value
                              ? new Date(e.target.value).toISOString()
                              : null
                          )
                        }
                        className="w-full px-3 py-2 border border-slate-300 rounded text-sm"
                      />
                      <label>A/R</label>
                      <input
                        type="checkbox"
                        checked={formData.depotGreffear || false}
                        onChange={(e) =>
                          handleChange("depotGreffear", e.target.checked)
                        }
                        className="w-4 h-4"
                      />
                    </div>

                    <div className="grid grid-cols-[15%_5%_25%_5%_5%] items-center gap-2 mt-2">
                      <label>Récépissé dépôt</label>
                      <input
                        type="checkbox"
                        checked={formData.recepissecheck || false}
                        onChange={(e) =>
                          handleChange("recepissecheck", e.target.checked)
                        }
                        className="w-4 h-4"
                      />
                      <input
                        type="date"
                        value={
                          formData.recepisse
                            ? new Date(formData.recepisse)
                                .toISOString()
                                .slice(0, 16)
                            : ""
                        }
                        onChange={(e) =>
                          handleChange(
                            "recepisse",
                            e.target.value
                              ? new Date(e.target.value).toISOString()
                              : null
                          )
                        }
                        className="w-full px-3 py-2 border border-slate-300 rounded text-sm"
                      />
                      <label>A/R</label>
                      <input
                        type="checkbox"
                        checked={formData.recepissear || false}
                        onChange={(e) =>
                          handleChange("recepissear", e.target.checked)
                        }
                        className="w-4 h-4"
                      />
                    </div>

                    <div className="grid grid-cols-[15%_5%_25%_5%_5%] items-center gap-2 mt-2">
                      <label>2777-SD</label>
                      <input
                        type="checkbox"
                        checked={formData.sd2777check || false}
                        onChange={(e) =>
                          handleChange("sd2777check", e.target.checked)
                        }
                        className="w-4 h-4"
                      />
                      <input
                        type="date"
                        value={
                          formData.sd2777
                            ? new Date(formData.sd2777)
                                .toISOString()
                                .slice(0, 16)
                            : ""
                        }
                        onChange={(e) =>
                          handleChange(
                            "sd2777",
                            e.target.value
                              ? new Date(e.target.value).toISOString()
                              : null
                          )
                        }
                        className="w-full px-3 py-2 border border-slate-300 rounded text-sm"
                      />
                      <label>A/R</label>
                      <input
                        type="checkbox"
                        checked={formData.sd2777ar || false}
                        onChange={(e) =>
                          handleChange("sd2777ar", e.target.checked)
                        }
                        className="w-4 h-4"
                      />
                    </div>
                  </div>
                )}
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      )}

      <FicheClientOverlay
        client={ficheClientData}
        open={ficheClientOpen}
        loading={ficheClientLoading}
        initialTab="general"
        onClose={() => setFicheClientOpen(false)}
        onClientUpdated={(updated) => {
          ficheClientCache.current[updated.id] = updated;
          setFicheClientData(updated);
        }}
      />
    </div>
  );
};

export default SuiviJuridiqueAGO;
